import { jsx as t } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ t(
  "path",
  {
    fill: "#212134",
    d: "M22 20v2H2v-2h1v-6.758A4.496 4.496 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.702 4.682A4.496 4.496 0 0 1 21 13.242V20h1ZM5.789 4 3.356 8.213a2.5 2.5 0 0 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.501 2.501 0 1 0 4.457-2.232L18.21 4H5.789Z"
  }
) }), a = o;
export {
  a as default
};
